export default __webpack_public_path__ + "static/media/mua-sam.7bfb6ae2.jpg";